import { ProjectDetailState, ProjectDetailAction } from '@/types/state';

export const initialProjectDetailState: ProjectDetailState = {
  // Selection & UI
  selectedFolderId: null,
  selectedSessionIds: new Set(),
  targetProjectId: '',
  activityExpanded: false,
  
  // Dialog states
  editNameDialog: false,
  editDescDialog: false,
  deleteDialog: false,
  editSessionDialog: false,
  deleteSessionDialog: false,
  folderDialog: false,
  moveSessionDialog: false,
  
  // Edit fields
  editedName: '',
  editedDescription: '',
  editedSessionName: '',
  selectedSession: null,
};

export function projectDetailReducer(
  state: ProjectDetailState,
  action: ProjectDetailAction
): ProjectDetailState {
  switch (action.type) {
    case 'SET_SELECTED_FOLDER_ID':
      return { ...state, selectedFolderId: action.payload };

    case 'TOGGLE_SESSION_SELECTION': {
      const newSet = new Set(state.selectedSessionIds);
      if (newSet.has(action.payload)) {
        newSet.delete(action.payload);
      } else {
        newSet.add(action.payload);
      }
      return { ...state, selectedSessionIds: newSet };
    }

    case 'TOGGLE_SELECT_ALL_SESSIONS':
      // This logic will now be handled in the hook where sessions data is available
      return state;

    case 'CLEAR_SESSION_SELECTION':
      return { ...state, selectedSessionIds: new Set() };

    case 'SET_TARGET_PROJECT_ID':
      return { ...state, targetProjectId: action.payload };

    case 'TOGGLE_ACTIVITY_EXPANDED':
      return { ...state, activityExpanded: !state.activityExpanded };

    case 'OPEN_EDIT_NAME_DIALOG':
      return {
        ...state,
        editNameDialog: true,
        editedName: action.payload,
      };

    case 'CLOSE_EDIT_NAME_DIALOG':
      return {
        ...state,
        editNameDialog: false,
        editedName: '',
      };

    case 'OPEN_EDIT_DESC_DIALOG':
      return {
        ...state,
        editDescDialog: true,
        editedDescription: action.payload,
      };

    case 'CLOSE_EDIT_DESC_DIALOG':
      return {
        ...state,
        editDescDialog: false,
        editedDescription: '',
      };

    case 'OPEN_DELETE_DIALOG':
      return { ...state, deleteDialog: true };

    case 'CLOSE_DELETE_DIALOG':
      return { ...state, deleteDialog: false };

    case 'OPEN_EDIT_SESSION_DIALOG':
      return {
        ...state,
        editSessionDialog: true,
        selectedSession: action.payload,
        editedSessionName: action.payload.name,
      };

    case 'CLOSE_EDIT_SESSION_DIALOG':
      return {
        ...state,
        editSessionDialog: false,
        selectedSession: null,
        editedSessionName: '',
      };

    case 'OPEN_DELETE_SESSION_DIALOG':
      return {
        ...state,
        deleteSessionDialog: true,
        selectedSession: action.payload,
      };

    case 'CLOSE_DELETE_SESSION_DIALOG':
      return {
        ...state,
        deleteSessionDialog: false,
        selectedSession: null,
      };

    case 'OPEN_FOLDER_DIALOG':
      return { ...state, folderDialog: true };

    case 'CLOSE_FOLDER_DIALOG':
      return { ...state, folderDialog: false };

    case 'OPEN_MOVE_SESSION_DIALOG':
      return { ...state, moveSessionDialog: true };

    case 'CLOSE_MOVE_SESSION_DIALOG':
      return {
        ...state,
        moveSessionDialog: false,
        targetProjectId: '',
      };

    case 'SET_EDITED_NAME':
      return { ...state, editedName: action.payload };

    case 'SET_EDITED_DESCRIPTION':
      return { ...state, editedDescription: action.payload };

    case 'SET_EDITED_SESSION_NAME':
      return { ...state, editedSessionName: action.payload };

    default:
      return state;
  }
}
